import { Pastille } from '../ui/Primitives';

/**
 * État d'expédition renvoyé par l'API (`etatExpedition` côté serveur). Le front
 * ne devine rien : c'est le serveur qui sait quels canaux sont raccordés.
 */
export interface EtatExpedition {
  expediteur: string;
  operationnelle: boolean;
  canaux: ('EMAIL' | 'SMS' | 'IN_APP')[];
  email: boolean;
  sms: boolean;
}

/**
 * Bandeau qui dit ce qui quitte réellement la plateforme.
 *
 * Trois états, et un seul écran de code pour les trois : les écrans des
 * relances, des notifications et des absences affichaient chacun leur propre
 * phrase, ce qui a fini par mentir dès que le mail a été raccordé sans le SMS.
 *
 * - rien de raccordé : avertissement, tout est tracé sans partir ;
 * - mail raccordé, SMS non : information, les SMS restent tracés ;
 * - tout raccordé : aucun bandeau, il n'y a rien à signaler.
 */
export function BandeauExpedition({
  etat,
  contexte,
}: {
  etat: EtatExpedition | undefined;
  /** Une phrase propre à l'écran, ajoutée après l'explication commune. */
  contexte?: string;
}): JSX.Element | null {
  if (!etat) return null;
  if (etat.email && etat.sms) return null;

  const rienNeSort = !etat.operationnelle;

  return (
    <div
      className={`rounded-2xl p-4 text-sm text-codialis-navy sm:p-5 ${
        rienNeSort ? 'bg-amber-50' : 'bg-codialis-sand'
      }`}
    >
      {rienNeSort ? <Pastille texte="Expédition non active" ton="warning" /> : null}
      <p className={`leading-relaxed${rienNeSort ? ' mt-2' : ''}`}>
        {rienNeSort ? (
          <>
            Aucun prestataire d’envoi n’est raccordé. Les messages sont composés avec leurs
            destinataires réels, tracés et journalisés, mais rien ne quitte la plateforme.
          </>
        ) : (
          <>
            Les e-mails partent par <strong>{etat.expediteur}</strong>. Le canal SMS n’est
            pas raccordé : les SMS sont composés et tracés, mais ils ne sont pas expédiés.
          </>
        )}
        {contexte ? ` ${contexte}` : null}
      </p>
    </div>
  );
}
